import { API_TYPE } from '@umu/umu-fetch';
const PHP_BASE = '/uapi/v1/market/order';

/**
 * 购物车相关接口
 */
export const ShoppingCartAPI = {
    /**
     * 前台获取课程购买记录
     */
    GET_COURSE_PURCHASE_RECORDS: {
        url: `${PHP_BASE}/get-course-purchase-records`,
        type: API_TYPE.GET,
    },

    /**
     * 批量添加课程到购物车
     */
    BATCH_ADD_SHOPPING_CART_COURSE: {
        url: `${PHP_BASE}/batch-add-shopping-cart-course`,
        type: API_TYPE.POST,
    },

    /**
     * 课程批量立即购买的接口
     */
    BATCH_PURCHASE_COURSE: {
        url: `${PHP_BASE}/batch-purchase-course`,
        type: API_TYPE.POST,
    },

    /**
     * 购物车列表接口
     */
    SHOPPING_CART_COURSE_LIST: {
        url: `${PHP_BASE}/shopping-cart-course-list`,
        type: API_TYPE.GET,
    },

    /**
     * 获取购物车中课程已选购买方式及可用的购买方式
     */
    GET_SHOPPING_CART_COURSE_PURCHASE_METHOD: {
        url: `${PHP_BASE}/get-shopping-cart-course-purchase-method`,
        type: API_TYPE.GET,
    },

    /**
     * 设置购物车中课程的购买方式
     */
    SET_SHOPPING_CART_COURSE_PURCHASE_METHOD: {
        url: `${PHP_BASE}/set-shopping-cart-course-purchase-method`,
        type: API_TYPE.POST,
    },

    /**
     * 管理后台获取课程市场购买数据
     */
    GET_PURCHASE_RECORDS: {
        url: `${PHP_BASE}/get-purchase-records`,
        type: API_TYPE.GET,
    },

    /**
     * 删除购物车中的课程
     */
    DELETE_SHOPPING_CART_COURSE: {
        url: `${PHP_BASE}/delete-shopping-cart-course`,
        type: API_TYPE.POST,
    },

    /**
     * 获取订单结算详情
     */
    GET_SETTLEMENT_INFO: {
        url: `${PHP_BASE}/get-settlement-info`,
        type: API_TYPE.GET,
    },

    /**
     * 管理后台下载课程市场购买数据
     */
    OUTPUT_PURCHASE_RECORDS: {
        url: `${PHP_BASE}/output-purchase-records`,
        type: API_TYPE.GET,
    },

    /**
     * 获取订单对公汇款账号信息
     */
    GET_ORDER_WIRE_TRANSFER_INFO: {
        url: `${PHP_BASE}/get-order-wire-transfer-info`,
        type: API_TYPE.GET,
    },

    /**
     * 获取订单状态
     */
    GET_ORDER_STATUS: {
        url: `${PHP_BASE}/get-order-status`,
        type: API_TYPE.GET,
    },

    /**
     * 获取订单列表
     */
    GET_ORDER_LIST: {
        url: `${PHP_BASE}/get-order-list`,
        type: API_TYPE.GET,
    },

    /**
     * 获取清华课程市场订单列表
     */
    GET_TISINGHUA_ORDER_LIST: {
        url: '/uapi/v1/payment/tsinghua-paid-list',
        type: API_TYPE.GET,
    },

    /**
     * 查询订单详情
     */
    GET_ORDER_INFO: {
        url: `${PHP_BASE}/get-order-info`,
        type: API_TYPE.GET,
    },

    /**
     * 上传汇款凭据
     */
    UPLOAD_TRANSFER_RECEIPT_URL: {
        url: `${PHP_BASE}/upload-transfer-receipt-url`,
        type: API_TYPE.POST,
    },

    /**
     * 查看汇款凭据接口
     */
    GET_TRANSFER_RECEIPT_URL: {
        url: `${PHP_BASE}/get-transfer-receipt-url`,
        type: API_TYPE.GET,
    },

    /**
     * 创建支付订单
     */
    CREATE_PAY_ORDER: {
        url: `${PHP_BASE}/create-pay-order`,
        type: API_TYPE.GET,
    },

    /**
     * 获取订单发票详情接口
     */
    GET_ORDER_INVOICE: {
        url: `${PHP_BASE}/get-order-invoice`,
        type: API_TYPE.GET,
    },

    /**
     * 获取购物车条数
     */
    GET_SHOPPING_CART_COUNT: {
        url: `${PHP_BASE}/shopping-cart-course-num`,
        type: API_TYPE.GET,
    },
};
